import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CountDownComponent } from '../../components/countdown/countdown.component';

@Component({
    selector: 'app-bets-status',
    imports: [CommonModule, CountDownComponent],
    templateUrl: './bets-status.component.html',
    styleUrl: './bets-status.component.scss'
})
export class BetsStatusComponent {
    private static readonly defaultHurryUpPoint = 0.33;

    @Input()
    initialTimeInSeconds!: number;

    @Input()
    animate = true;

    @Input()
    hurryUpPoint = BetsStatusComponent.defaultHurryUpPoint;

    protected hurryUp = false;

    onCountDownProgress(progress: number): void {
        this.hurryUp = progress < this.hurryUpPoint;
    }
}
